<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div v-if="isImmersion01Finished()" class="finished-list mt-4">
    <h5 class="font-weight-bold">Revis les meilleurs moments !</h5>
    <b-button variant="light" @click="$router.push('/scarf')">Revoir les foulards créés</b-button>
    <b-button variant="light" @click="$router.push('/immersion01/5')">Revoir le jeu de piste</b-button>
    <b-button variant="light" @click="$router.push('/immersion01/8')">Revoir le camp dessiné</b-button>
    <b-button variant="light" @click="$router.push('/immersion02/5')">Revoir les souvenirs</b-button>
  </div>
</template>

<script>
export default {
  methods: {
    isImmersion01Finished: function () {
      return window.localStorage.getItem("immersion01_finished") === "yes";
    }
  }
};
</script>

<style lang="scss" scoped>
.finished-list {
  button {
    margin: 5px;
    margin-bottom: 10px;
  }
}
</style>
